import { render } from "./DoBest.vue?vue&type=template&id=05b5f698&scoped=true"
import script from "./DoBest.vue?vue&type=script&lang=js"
export * from "./DoBest.vue?vue&type=script&lang=js"

import "./DoBest.vue?vue&type=style&index=0&id=05b5f698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b5f698"]])

export default __exports__